import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-5" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "col-sm-6" }
const _hoisted_7 = { class: "col-lg-7" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-lg-6 col-xxl-5" }
const _hoisted_10 = { class: "col-lg-6 col-xxl-2" }
const _hoisted_11 = { class: "col-lg-12 col-xxl-5" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-lg-7 col-xl-8 col-md-6" }
const _hoisted_14 = { class: "col-lg-5 col-xl-4 col-md-6" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-xl-4" }
const _hoisted_17 = { class: "col-xl-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_YourScheduleToday = _resolveComponent("YourScheduleToday")!
  const _component_OverallVisitorsChart = _resolveComponent("OverallVisitorsChart")!
  const _component_PatientsChart = _resolveComponent("PatientsChart")!
  const _component_PatientAdmissionsDischargesChart = _resolveComponent("PatientAdmissionsDischargesChart")!
  const _component_EmergencyRoomVisitsChart = _resolveComponent("EmergencyRoomVisitsChart")!
  const _component_CriticalPatientsChart = _resolveComponent("CriticalPatientsChart")!
  const _component_BedOccupancyRateChart = _resolveComponent("BedOccupancyRateChart")!
  const _component_PatientAppointments = _resolveComponent("PatientAppointments")!
  const _component_ScheduleAppointment = _resolveComponent("ScheduleAppointment")!
  const _component_PatientByAgeChart = _resolveComponent("PatientByAgeChart")!
  const _component_HospitalEarnings = _resolveComponent("HospitalEarnings")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_YourScheduleToday),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_OverallVisitorsChart)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_PatientsChart)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_PatientAdmissionsDischargesChart)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_EmergencyRoomVisitsChart)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_CriticalPatientsChart)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_BedOccupancyRateChart)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_PatientAppointments)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_ScheduleAppointment)
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_PatientByAgeChart)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_HospitalEarnings)
      ])
    ])
  ]))
}